import { createStyles } from "@mantine/core";

const  EmployeeImportStatusBadgeStyles = createStyles(() => ({
  label: {
    padding: "6px 12px 5px",
    borderRadius: "32px",
    fontSize: "11px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1,
    letterSpacing: "0.16px",
    textAlign: "left",
    color: "#495057",
  },
  importing: {
    backgroundColor: "rgba(255,212,59, 0.3)",
  },
  uploaded: {
    backgroundColor: "#ced4da",
  },
  imported: {
    backgroundColor: "rgba(32,201,151, 0.3)",
  },
  cancelled: {
    backgroundColor: "rgba(240,62,62, 0.3)",
  },
  processed: {
    backgroundColor: "rgba(32,201,151, 0.3)",
  },
}));


export default  EmployeeImportStatusBadgeStyles;